import CalendarLocale from '../../rc-components/calendar/locale/th_TH';
import TimePickerLocale from '../../time-picker/locale/th_TH';
// Merge into a locale object
const locale = {
    lang: {
        placeholder: 'เลือกวันที่',
        rangePlaceholder: ['วันเริ่มต้น', 'วันสิ้นสุด'],
        ...CalendarLocale,
    },
    timePickerLocale: { ...TimePickerLocale },
};
// All settings at:
export default locale;
